import axios from "axios"

import { removeBrTag } from "@p-ban/common/src/utils/StringUtils"

import { convertForServer, convertForServerByParams } from "../../features/oneClickEstimate/pcb/service/converter"
import type EstimateValues from "../../features/oneClickEstimate/types/params"
import type { EstimateParams } from "../../features/oneClickEstimate/types/params"
import type { EstimateErrorResult, EstimateErrors, EstimateResult } from "./csComEst.d"

export const END_POINT = {
  PING: "/kiban/com/jq/csComEst:ping.do",
  EXEC: "/kiban/com/jq/csComEst:exec.do",
  RULES: "/kiban/utf-8/com/csComEst:quotationRules.do",
  PRINT: "/kiban/utf-8/com/csComEst:print.do",
} as const

const csComEstApi = {
  ping() {
    // セッション維持が目的でエラーになってもアプリケーションの実行に大きな影響はないため、例外は握りつぶします。
    axios.post(END_POINT.PING).catch(() => {})
  },

  async exec({
    values,
    options: { repCnt } = {},
    procurementValues,
    meta,
    bomSnapshotId,
    deliveryZeroFlg,
    mountQuickFlg,
  }: EstimateParams) {
    const res = await axios.post<EstimateResult | string>(END_POINT.EXEC, {
      ...convertForServerByParams({
        values,
        options: { repCnt },
        procurementValues,
        meta,
        bomSnapshotId,
        deliveryZeroFlg,
        mountQuickFlg,
      }),
      repCnt: repCnt?.toString() ?? "",
      ...procurementValues,
      ...meta,
      bomSnapshotId,
      deliveryZeroFlg,
    })

    if (typeof res.data === "string") {
      throw new Error("HTMLが返却されました")
    }

    // エラーメッセージにbrタグが含まれてしまってるので取り除きます。
    // TODO サーバー側のエラーメッセージ定義を直してこの処理を外す。
    if (res.data.isError) {
      const messages: EstimateErrors = {}
      const entries = Object.entries(res.data.messages) as [keyof EstimateErrors, string | undefined][]
      entries.forEach(([key, value]) => {
        if (value) {
          messages[key] = removeBrTag(value)
        }
      })

      return { isError: true, messages } as EstimateErrorResult
    }

    return res.data
  },
  /**
   * 設計項目の閾値（最小パターン幅、最小ランド径）を取得する
   * @param values
   */
  async quotationRules(values: EstimateValues) {
    type Enum = {
      id: string
      describe: string
      value: number
    }

    type MinThresholdAndStandard = {
      minThreshold: Enum | null
      standard: Enum | null
    }

    type QuotationRules = {
      minLand: MinThresholdAndStandard
      minPattern: MinThresholdAndStandard
    }

    const res = await axios.post<QuotationRules>(END_POINT.RULES, convertForServer(values))
    return res.data
  },

  print(paramStringify: string, resultStringify: string) {
    const target = "new_window"

    window.open(
      "",
      target,
      "top=10,left=10,status=no,scrollbars=yes,directories=no,menubar=no,resizable=yes,toolbar=no",
    )

    const form = document.createElement("form")
    form.action = END_POINT.PRINT
    form.method = "POST"
    form.target = target
    form.innerHTML = `
    <input type="hidden" name="paramStringify" value='${paramStringify}' />
    <input type="hidden" name="resultStringify" value='${resultStringify}' />
   `
    document.body.appendChild(form)
    form.submit()
    form.parentNode?.removeChild(form)
  },
}

export default csComEstApi
